import { useCallback, useMemo, useReducer } from "react";

import { actions, INITIAL_STATE, reducer } from "./reducers/booking_data";
import {
  clearSavedState,
  getSavedState,
  setSavedState,
} from "./reducers/booking_data/utils/manage_saved_state";

export default () => {
  const [bookingData, dispatch] = useReducer(reducer, INITIAL_STATE);

  const setParams = useCallback((newParams) => {
    return actions.setParams(dispatch, newParams);
  }, []);

  const resetParams = useCallback(() => {
    return actions.resetParams(dispatch);
  }, []);

  const setParamsAndLoadPropertyUnitsInfo = useCallback((channelId, newParams) => {
    return actions.setParamsAndLoadPropertyUnitsInfo(dispatch, channelId, newParams);
  }, []);

  const loadProperty = useCallback((channelId, type) => {
    return actions.loadProperty(dispatch, channelId, type);
  }, []);

  const loadPropertyUnitsInfo = useCallback((channelId, params) => {
    return actions.loadPropertyUnitsInfo(dispatch, channelId, params);
  }, []);

  const loadClosedDates = useCallback((channelId, type) => {
    return actions.loadClosedDates(dispatch, channelId, type);
  }, []);

  const initBookingData = useCallback((bookingQueryParams, savedBookingData) => {
    return actions.initBookingData(dispatch, bookingQueryParams, savedBookingData);
  }, []);

  const loadBestOffer = useCallback((channelId, type, params) => {
    return actions.loadBestOffer(dispatch, channelId, type, params);
  }, []);

  const loadChannelsFromProperty = useCallback((propertyId) => {
    return actions.loadChannelsFromProperty(dispatch, propertyId);
  }, []);

  const clearPropertyUnitsInfo = useCallback((params) => {
    return actions.clearPropertyUnitsInfo(dispatch, params);
  }, []);

  const saveDataToStorage = useCallback((bookingDataToSave) => {
    setSavedState(bookingDataToSave);
  }, []);

  const getDataFromStorage = useCallback(() => {
    return getSavedState();
  }, []);

  const clearDataFromStorage = useCallback(() => {
    clearSavedState();
  }, []);

  const bookingActions = useMemo(
    () => ({
      initBookingData,
      setParams,
      resetParams,
      setParamsAndLoadPropertyUnitsInfo,

      loadProperty,
      loadPropertyUnitsInfo,
      loadClosedDates,
      loadBestOffer,
      loadChannelsFromProperty,
      clearPropertyUnitsInfo,

      saveDataToStorage,
      getDataFromStorage,
      clearDataFromStorage,
    }),
    [
      initBookingData,
      setParams,
      resetParams,
      setParamsAndLoadPropertyUnitsInfo,

      loadProperty,
      loadPropertyUnitsInfo,
      loadClosedDates,
      loadBestOffer,
      loadChannelsFromProperty,
      clearPropertyUnitsInfo,

      saveDataToStorage,
      getDataFromStorage,
      clearDataFromStorage,
    ],
  );

  return useMemo(() => ({ bookingData, bookingActions }), [bookingData, bookingActions]);
};
